import React, { useRef, useEffect, useState, useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography, TextField } from '@material-ui/core';

import useForm from 'hooks/useForm';

import { I18nManagerContext } from 'contexts/I18nManager';
import SelectField from 'components/core/SelectField';
import { AuthManagerContext } from 'contexts/AuthManager'

const useStyles = makeStyles(theme => ({
    subtitle: {
        // display: 'none',
        // [theme.breakpoints.up('sm')]: {
            display: 'block',
            paddingLeft: theme.spacing(1/4)
        // },
    },
    form: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%'
    },
    formTitle: {
        paddingBottom: theme.spacing(5)
    },
    textField: {
        width: theme.spacing(41)
    }
}))

const InputLabelProps = {
    required: false //Hide asterix on required field
}

export default function PatientDeviceForm({ title = 'Pathway Information', record, params = {}, isSubmitting, onSubmit, onError }) {
    const classes = useStyles()
    const ref = useRef()
    const validations = { deviceId: ['required'], serialNumber: ['required'] }
    const [state, errors, handleChange, handleBlur, handleSubmit] = useForm(callback, validations, record)
    const authManager = useContext(AuthManagerContext)

    function callback() {
        if (onSubmit) onSubmit(state)
    }

    useEffect(() => {
        (Object.keys(errors).length > 0 && onError && onError(errors))
    }, [errors])

    useEffect(() => {
        (isSubmitting === true && handleSubmit())
    }, [isSubmitting])

    // console.log(state)

    return (
        <form ref={ref} className={classes.form} autoComplete="off" onSubmit={handleSubmit} noValidate>
            {/* <Typography className={classes.formTitle} variant="h5" color="textSecondary" noWrap>
                {title}
            </Typography> */}
            <SelectField
                InputLabelProps={InputLabelProps}
                autoComplete="off"
                margin="normal"
                id="pathwayId"
                label="Pathway"  // TODO: 
                defaultValue={state ? (state.pathwayId || "") : ""}
                fullWidth
                required={true}
                error={!!errors['pathwayId']}
                helperText={!!errors['pathwayId'] && errors['pathwayId']}
                resource={(authManager.customerId && params.patientId) && { path: '/customers/:customerId/patients/:patientId/pathways', params: { customerId: params.customerId || authManager.customerId, patientId: params.patientId } }}
                onChange={handleChange}
                onBlur={handleBlur}
                textName="pathway"
                valueName="id"
            />
            <SelectField
                InputLabelProps={InputLabelProps}
                autoComplete="off"
                margin="normal"
                id="deviceId"
                label="Device Type"     // TODO: 
                defaultValue={state ? (state.deviceId || "") : ""}
                fullWidth
                required={true}
                error={!!errors['deviceId']}
                helperText={!!errors['deviceId'] && errors['deviceId']}
                resource={{ path: '/customers/:customerId/devices', params: { customerId: authManager.customerId } }}
                params={state.pathwayId && { pathwayId: state.pathwayId}}
                onChange={handleChange}
                onBlur={handleBlur}
                textName="name"
                valueName="id"
            />
            <SelectField
                InputLabelProps={InputLabelProps}
                autoComplete="off"
                margin="normal"
                id="serialNumber"
                label="Serial Number"     // TODO: 
                defaultValue={state ? (state.serialNumber || "") : ""}
                fullWidth
                required={true}
                error={!!errors['serialNumber']}
                helperText={!!errors['serialNumber'] && errors['serialNumber']}
                resource={(authManager.customerId && state.deviceId) && { path: '/customers/:customerId/devices/:deviceId/serialnumbers', params: { customerId: authManager.customerId, deviceId: state.deviceId } }}
                onChange={handleChange}
                onBlur={handleBlur}
                textName="serialNumber"
                valueName="serialNumber"
                disabled={state && state.deviceId ? false : true}
            />
        </form>
    )
}